module.exports = __webpack_public_path__ + "img/dog.1bc737c2.webp";